import { Component, Input, OnInit } from '@angular/core';
import { DateService } from '../../shared/core/date.service';

@Component({
  selector: 'rl-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {

  @Input() start : Date;
  @Input() end : Date;
  @Input() showOnlyInRange : boolean;

  isInDateRange : boolean;

  constructor(private dateService : DateService) { }

  ngOnInit(): void {
    this.isInDateRange = this.dateService.isTodayBetweenDates(this.start, this.end);
  }

}
